import { render, staticRenderFns } from "./PandemicDatabaseApplication.vue?vue&type=template&id=a02ed628&"
import script from "./PandemicDatabaseApplication.vue?vue&type=script&lang=js&"
export * from "./PandemicDatabaseApplication.vue?vue&type=script&lang=js&"
import style0 from "./PandemicDatabaseApplication.vue?vue&type=style&index=0&id=a02ed628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports